import React from 'react'
import { Button, ButtonGroup } from 'react-bootstrap'
import useButtonLoading from '../../hooks/ButtonLoading'
import { EqxLink } from '@equinoxx/react'
import EqxLoading from '../EqxLoading'
import './EqxButton.css'

function isInternalRouteHref(href?: string, target?: string, download?: string): boolean {
    if (!href) return false
    if (download) return false
    if (target && target !== '_self') return false
    if (href.startsWith('#')) return false
    if (href.startsWith('mailto:') || href.startsWith('tel:')) return false
    if (/^(?:https?:)?\/\//i.test(href)) return false
    return href.startsWith('/')
}

const EqxButton = function (props: {
    children?: React.ReactNode
    size?: 'sm' | 'lg'
    type?: 'create' | 'add' | 'edit' | 'delete' | 'save' | 'cancel'
    text?: string | React.ReactNode
    icon?: string
    colourType?: string
    variant?: string
    href?: string
    download?: string
    tooltip?: string
    disabled?: boolean
    id?: string
    className?: string
    target?: string
    showText?: boolean | ('sm' | 'md' | 'lg' | 'xl' | 'xxl')
    fullWidth?: boolean
    onClick?: (e: React.MouseEvent<Element, MouseEvent>) => any
}) {
    const { loading, onClick } = useButtonLoading(props.onClick)
    let { children, type, icon, text, colourType, showText, fullWidth, ...buttonProps } = props
    if (type) {
        let colour = null
        switch (type) {
            case 'create':
            case 'add':
                colour = 'success'
                icon = icon ?? 'fas fa-plus'
                text = text ?? 'Add'
                break
            case 'edit':
                colour = 'warning'
                icon = icon ?? 'fas fa-pencil'
                text = text ?? 'Edit'
                break
            case 'delete':
                colour = 'danger'
                icon = icon ?? 'fas fa-trash'
                text = text ?? 'Delete'
                break
            case 'save':
                colour = 'success'
                icon = icon ?? 'fas fa-save'
                text = text ?? 'Save'
                break
            case 'cancel':
                colour = 'secondary'
                colourType = 'outline'
                icon = icon ?? 'fas fa-times'
                text = text ?? 'Cancel'
                break
        }
        if (colour) buttonProps.variant = buttonProps.variant ?? (colourType != 'outline' ? '' : 'outline-') + colour
    }
    const disabled = props.disabled || loading
    const className = `${props.className ?? ''}${props.fullWidth ? ' w-100' : ''}`
    const shouldUseRouterLink = isInternalRouteHref(props.href, props.target, props.download)
    const content = loading ? (
        <EqxLoading size="sm" />
    ) : (
        children ?? (
            <>
                {icon && <span className={icon}></span>}{' '}
                {text && <span className={props.showText === true ? 'd-inline' : 'd-none d-' + (props.showText ?? 'sm') + '-inline'}>{text}</span>}
            </>
        )
    )
    const baseButtonProps = {
        ...buttonProps,
        className,
        disabled,
        onClick: props.onClick ? onClick : undefined,
    }

    if (shouldUseRouterLink) {
        const buttonLinkProps = { ...baseButtonProps } as any
        delete buttonLinkProps.href
        return (
            <Button
                {...buttonLinkProps}
                as={EqxLink as any}
                to={props.href}
            >
                {content}
            </Button>
        )
    }

    return (
        <Button {...baseButtonProps}>
            {content}
        </Button>
    )
}
const EqxButtonGroup = (props: { children: React.ReactNode; separate?: boolean }) => {
    if (props.separate) {
        return <div className="eqx-btn-group-separate">{props.children}</div>
    }
    return <ButtonGroup>{props.children}</ButtonGroup>
}
export { EqxButton as default, EqxButtonGroup }

